module.exports = __webpack_public_path__ + "img/logo_symbol_white.64297fb7.webp";